// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b26d07ee","455":"b323f099"}[chunkId] + ".chunk.js";
};